import { render, staticRenderFns } from "./dialog-bottom.vue?vue&type=template&id=015325f5&scoped=true"
import script from "./dialog-bottom.vue?vue&type=script&lang=js"
export * from "./dialog-bottom.vue?vue&type=script&lang=js"
import style0 from "./dialog-bottom.vue?vue&type=style&index=0&id=015325f5&prod&lang=css"
import style1 from "./dialog-bottom.vue?vue&type=style&index=1&id=015325f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015325f5",
  null
  
)

export default component.exports